import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "../index.css";
import Dashboard from '../components/Dashboard';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Service from "../pages/Service";
import ServiceFollow from "../pages/ServiceFollow";
import { useNavigate } from "react-router-dom";
import Request from "../pages/Request";
import Follow from "../pages/Follow";
import Profile from "../pages/Profile";
import DashboardInternal from "../components/DashboardInternal";
import { ToastContainer, toast } from "react-toastify";

function Admin() {

  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate();

  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    }
  }, []);

  return (

    <div>
      <Header />
      {/* <Sidebar routes={routes}  toggle={false} /> */}
      <div className="rgc-main">
        <Routes>
          <Route path='dashboard' element={<Dashboard />} />
          <Route path='service/:requestId' element={<Service />} />
          <Route path='service/follow/:requestId' element={<ServiceFollow />} />
          <Route path='items/:internalId' element={<DashboardInternal />} />
          <Route path='follow/:requestId' element={<Follow />} />
          <Route path='request' element={<Request />} />
          <Route path='profile' element={<Profile />} />
        </Routes>

        <div className="rgc-toast">
            <ToastContainer autoClose={3000} />
          </div>
      </div>
      <Footer />
    </div>

  );
}

export default Admin;
